export interface NavItem {
  path: string;
  label: string;
  isAnchor?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { path: "#services", label: "Projects", isAnchor: true },
  { path: "#case-studies", label: "Case Studies", isAnchor: true },
  { path: "#testimonials", label: "Testimonials", isAnchor: true },
];
